declare global {
  interface Window {
    /** Runtime settings written to /config.js when the container starts (see build/config/nginx/runtime-config.sh). */
    __APP_CONFIG__?: Partial<ImportMetaEnv>;
  }
}

/**
 * Environment settings, resolved at runtime.
 *
 * In the container, /config.js (generated at startup from the container's VITE_* variables) sets
 * window.__APP_CONFIG__, so one image serves every environment. Elsewhere (dev server, tests,
 * static hosting) it is empty and the build-time import.meta.env values apply.
 */
export const appEnv: ImportMetaEnv = {
  ...import.meta.env,
  ...(typeof window === 'undefined' ? undefined : window.__APP_CONFIG__)
};
